import FileSize from "../../../../components/commonComponent/FileSize";
import PoliciesMenu from "./PoliciesMenu";
import { useEffect, useState } from "react";
import { ReactComponent as FaFacebookF } from "../../../../assets/images/FaFacebookF.svg";
import { ReactComponent as FaYoutube } from "../../../../assets/images/FaYoutube.svg";
import { ReactComponent as FaInstagram } from "../../../../assets/images/FaInstagram.svg";
import { ReactComponent as FaLinkedinIn } from "../../../../assets/images/FaLinkedinIn.svg";
import { ReactComponent as FaXTwitter } from "../../../../assets/images/FaXTwitter.svg";
import { Link } from "react-router";
import styled from "styled-components";

import phone from "../../../../assets/pages/landing/footer/phone.svg";
import pin from "../../../../assets/pages/landing/footer/pin.svg";
import mail from "../../../../assets/pages/landing/footer/mail.svg";
import { getVisitorCount } from "../../../../services/visitorService";
import { PdfPreviewModal } from "../../../rightToInformation/components/RtiContent/PdfDocumentTable";

import {
  FooterWrapper,
  FooterContent,
  FooterUnderline,
  FooterText,
  FooterLink,
  FooterNotice,
  FooterBottom,
} from "./Footer.styles";

const quickLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Schemes", path: "/schemes" },
  {
    label: "Right to Information",
    path: "/right-to-information/right-to-information-act",
  },
  { label: "Contact Us", path: "/contact" },
  { label: "Employee Corner", path: "/login" },
];

const importantLinks = [
  {
    label: "India At A Glance",
    href: "https://www.india.gov.in/explore-india/facts-of-india/india-at-a-glance",
  },
  {
    label: "Swachh Bharat",
    href: "https://swachhbharatmission.ddws.gov.in/",
  },
  {
    label: "My Government",
    href: "https://www.mygov.in/",
  },
  {
    label: "SHe-Box",
    href: "https://shebox.wcd.gov.in/",
  },
  {
    label: "National Portal of India",
    href: "https://www.india.gov.in/",
  },
];

const socialLinks = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/NMDFCIndiaa/",
    Icon: FaFacebookF,
  },
  {
    label: "X",
    href: "https://x.com/NMDFCIndia",
    Icon: FaXTwitter,
  },
  {
    label: "YouTube",
    href: "https://youtube.com/@nmdfcindia?si=_165B2gioXuyzsX2",
    Icon: FaYoutube,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/nmdfc/",
    Icon: FaLinkedinIn,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/nmdfcindia/",
    Icon: FaInstagram,
  },
];

const FooterSection = ({ title, children }) => (
  <FooterSectionWrapper>
    <h2 className="text-white text-xl">{title}</h2>
    <FooterUnderline />
    {children}
  </FooterSectionWrapper>
);

const FooterSectionWrapper = styled.div`
  position: relative;


`;

const scrollToTop = () => {
  window.setTimeout(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, 0);
};

const Footer = () => {
  const [visitorCount, setVisitorCount] = useState("Loading...");
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    let isMounted = true;

    getVisitorCount()
      .then((count) => {
        if (isMounted && count !== null) {
          setVisitorCount(count.toLocaleString("en-IN"));
        } else if (isMounted) {
          setVisitorCount("--");
        }
      })
      .catch((error) => {
        console.error("Unable to load visitor count:", error);
        if (isMounted) {
          setVisitorCount("Unavailable");
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <FooterWrapper>
      <FooterContent>
        <FooterSection title="About NMDFC">
          <FooterText>
         NMDFC (National Minorities Development & Finance Corporation) is a Government of India undertaking under the Ministry of Minority Affairs. The organization works towards the economic and educational empowerment of minority communities through concessional loans, skill development, and self-employment support schemes.
          </FooterText>
        </FooterSection>

        <FooterSection title="Quick Links">
          {quickLinks.map((link) =>
            link.href ? (
              <FooterLink
                href={link.href}
                key={link.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
              </FooterLink>
            ) : (
              <FooterLink
                as={Link}
                to={link.path}
                key={link.path}
                onClick={scrollToTop}
              >
                {link.label}
              </FooterLink>
            )
          )}
        </FooterSection>

        <FooterSection title="Important Links">
          {importantLinks.map((link) => (
            <FooterLink
              href={link.href}
              key={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.label}<FileSize href={link.href} />
            </FooterLink>
          ))}
        </FooterSection>

        <FooterSection title="Contact Info">
          <FooterText className="mb-4 flex items-start gap-2">
            <img src={pin} className="h-6" style={{ filter: "brightness(0) invert(1)" }} alt="" />
            <span> 1st Floor, Core-1, Scope Minar, Laxmi Nagar,New Delhi, 110092</span>
          </FooterText>
          <FooterText className="mb-4 flex items-start gap-2">
            <img src={phone} className="h-6" style={{ filter: "brightness(0) invert(1)" }} alt="" />
            <span>22441442 / 44 / 52 / 53 / 55</span>
          </FooterText>
          <FooterText className="flex items-start gap-2">
            <img src={mail} className="h-6" style={{ filter: "brightness(0) invert(1)" }} alt="" />
            <span translate="no" className="dont-translate bhashini-skip-translation">nmdfc123[at]gmail[Dot]com</span>
          </FooterText>
          
        </FooterSection>

        <FooterSection title="Social Media">
          <div className="flex flex-wrap gap-3 text-white text-2xl">
            {socialLinks.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit NMDFC on ${label}`}
                title={label}
                className="inline-flex text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#005f63]"
              >
                <Icon aria-hidden="true" />
              </a>
            ))}
          </div>
          <div className="space-y-2">
            <div>
              <p className="text-white text-sm mt-5">Last Updated On : 09 sep 2026  </p>
              <FooterUnderline />
             
            </div>
             <div style={{ marginTop: 'auto' }}>
               <p className="text-white text-sm">
                 Visitor Count : {visitorCount}
               </p>
               <FooterUnderline />
             </div>
           
          </div>
        </FooterSection>
      </FooterContent>

      <FooterNotice>
        <p>Copyright © 2026 - All Rights Reserved - Official Website of National Minorities Development &amp; Finance Corporation, Ministry of Minority Affairs, Government of India</p>
        <p>Note: Content on this website is published and managed by National Minorities Development &amp; Finance Corporation, Ministry of Minority Affairs</p>
        <p>For any query regarding this website, please contact the web information manager Vinod Kumar Prajapati (Deputy Manager )</p>
        <p>Email ID: <span translate="no" className="dont-translate bhashini-skip-translation">v[Dot]prajapati41[at]nic[Dot]in</span>, Contact No.: +91-11-22441442</p>
      </FooterNotice>

      <FooterBottom>
        <div>GSTIN07AAACN1752H1ZO</div>
        <div>
          <Link to="/help" onClick={scrollToTop}>Help</Link>
          <PoliciesMenu onSelect={setSelectedPdf} />
          <span>Accessibility</span>
        </div>
      </FooterBottom>

      {selectedPdf && (
        <PdfPreviewModal
          pdfDocument={selectedPdf}
          onClose={() => setSelectedPdf(null)}
        />
      )}
    </FooterWrapper>
  );
};

export default Footer;
